import type { ChauffeurPage } from "../slug-chauffeur";

import heroImage from "@/assets/images/chauffeur/events/event-soir.png";

const events: ChauffeurPage = {
  slug: "events",
  title: "Chauffeur for events – VTC & logistics",
  subtitle: "Shuttles, VIP, roadshows, seminars in Cannes and nearby.",
  keywords: ["chauffeur events", "vtc events"],
  hero: {
    title: "Chauffeurs for events",
    subtitle: "Coordination and premium welcome.",
    keywords: ["event logistics", "VIP chauffeur"],
    imageSrc: heroImage.src,
    imageAlt: "Chauffeurs for events",
    badges: ["Project lead", "Adaptable fleet", "Optimised routes"],
  },
  benefits: {
    heading: "Advantages for your events",
    items: [
      { title: "Project lead", description: "Dedicated on-site coordination." },
      { title: "Adaptable fleet", description: "Sedan, SUV, van, bus." },
      {
        title: "Optimised routes",
        description: "For friction-free flows.",
      },
    ],
  },
  services: {
    heading: "Use cases",
    services: [
      {
        title: "Congresses & trade shows",
        text: "Shuttles and guest welcome in Cannes (Palais des Festivals).",
      },
      { title: "Weddings", text: "Coordinated travel for guests." },
    ],
  },
  locations: {
    heading: "Covered venues",
    items: [{ name: "Nice" }, { name: "Cannes" }, { name: "Monaco" }],
  },
  generic: {
    heading: "On-site coordination",
    subheading: "A single, responsive point of contact in Cannes.",
    paragraphs: [
      "We orchestrate vehicle and guest flows to avoid any waiting during your events.",
      "This service suits congresses, product launches, weddings and VIP operations with tight timing constraints.",
      "With centralised steering, you keep a clear view of every rotation and every pick-up.",
    ],
    bullets: ["Project lead", "Chauffeur briefing", "Run sheet"],
  },
  process: {
    heading: "Event methodology",
    steps: [
      "Audit of passenger flows and pick-up points.",
      "Build the transport plan (vehicles, rotations, priorities).",
      "Operational chauffeur briefing and on-site coordination.",
      "Live tracking and adjustments during the event.",
    ],
  },
  faq: [
    {
      q: "How many vehicles can you mobilise for an event?",
      a: "Sizing depends on volume. We adapt the fleet to your constraints and timings.",
    },
    {
      q: "Is there a single point of contact during the event?",
      a: "Yes, an operational lead steers the coordination to keep your exchanges simple.",
    },
    {
      q: "Can you handle VIP guests and standard shuttles in parallel?",
      a: "Yes, we separate the flows to guarantee confidentiality, punctuality and comfort.",
    },
  ],
  relatedLinks: [
    {
      label: "Chauffeur during the Cannes Film Festival",
      href: "/en/chauffeur/cannes-film-festival",
    },
    { label: "Executive chauffeur at MIPIM", href: "/en/chauffeur/mipim" },
    { label: "Executive chauffeur at MIPCOM", href: "/en/chauffeur/mipcom" },
    {
      label: "Chauffeur during Cannes Lions",
      href: "/en/chauffeur/cannes-lions",
    },
    {
      label: "Chauffeur during Canneseries",
      href: "/en/chauffeur/canneseries",
    },
    { label: "Chauffeur during TFWA", href: "/en/chauffeur/tfwa-cannes" },
    {
      label: "Chauffeur at the Cannes Yachting Festival",
      href: "/en/chauffeur/cannes-yachting-festival",
    },
    {
      label: "Chauffeur during the Monaco Grand Prix",
      href: "/en/chauffeur/monaco-grand-prix",
    },
    {
      label: "Chauffeur during the Monaco Yacht Show",
      href: "/en/chauffeur/monaco-yacht-show",
    },
    {
      label: "Chauffeur during Jazz a Juan",
      href: "/en/chauffeur/jazz-a-juan",
    },
    { label: "Private chauffeur in Cannes", href: "/en/chauffeur/cannes" },
    { label: "Corporate chauffeur", href: "/en/chauffeur/business" },
    { label: "Contact the logistics team", href: "/contact" },
    {
      label: "Chauffeur-driven wedding car",
      href: "/en/chauffeur/wedding-car-cannes",
    },
  ],
  cta: {
    title: "Tell us about your event",
    text: "We offer bespoke, responsive logistics.",
    primaryHref: "/contact",
    primaryLabel: "Get a proposal",
  },
  seo: {
    title: "Event Chauffeur in Cannes, Nice and Monaco",
    description:
      "Cannes Film Festival, MIPIM, Cannes Lions, Monaco Grand Prix: a dedicated chauffeur from 240 € for 3 hours, guest shuttles for up to 16 people.",
    canonical: "/en/chauffeur/events",
  },
};

export default events;
